import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // SEO and Meta
      seo: {
        title: "JSON Path Finder - Online JSON Analyzer & Path Extractor Tool",
        description: "Free online JSON path finder and analyzer tool. Extract paths from JSON data, validate JSON structure, format JSON with syntax highlighting. Perfect for API testing and development.",
        keywords: "json path finder, json analyzer, json validator, json formatter, api tool, json extractor, online json tool"
      },
      
      // Header
      header: {
        title: "JSON Path Finder",
        subtitle: "Analyze JSON structure and extract paths with ease",
        json5Support: "JSON5 (comments)"
      },
      
      // JSON Input
      jsonInput: {
        title: "JSON Input",
        subtitle: "Paste your JSON object below",
        subtitleJson5: "Paste your JSON object below (JSON5 comments supported)",
        placeholder: "Paste your JSON here...",
        formatButton: "Format",
        highlightButton: "Highlight",
        formatTooltip: "Format JSON",
        highlightTooltip: "Toggle syntax highlighting"
      },
      
      // JSON Paths
      jsonPaths: {
        title: "JSON Paths",
        subtitle: "Click to select a path, expand/collapse with arrows",
        noData: "No JSON data to display",
        noDataHint: "Paste valid JSON in the left panel to see paths",
        noMatches: "No matches found",
        noMatchesHint: "Try adjusting your search query or check the regex syntax"
      },
      
      // Search
      search: {
        placeholder: "Search paths (supports regex)...",
        searchingFor: "Searching for:",
        regexMode: "REGEX",
        enableRegex: "Enable regex mode",
        disableRegex: "Disable regex mode"
      },
      
      // Selected Path
      selectedPath: {
        title: "Selected Path:",
        copied: "Path copied to clipboard! Click any path to copy it.",
        highlighted: "Highlighted:",
        line: "Line"
      },
      
      // Errors and Validation
      errors: {
        jsonError: "JSON Error:",
        suggestion: "Suggestion:",
        invalidRegex: "Invalid regex pattern:",
        regexHelp: "Please check your regular expression syntax"
      },
      
      // Toast Messages
      toast: {
        pathCopied: "Path copied to clipboard!"
      },
      
      // Footer
      footer: {
        copyright: "All rights reserved.",
        privacy: "Privacy Policy",
        imprint: "Imprint"
      },
      
      // Tool Features (for SEO)
      features: {
        pathExtraction: "Path Extraction",
        jsonValidation: "JSON Validation", 
        syntaxHighlighting: "Syntax Highlighting",
        searchFilter: "Search & Filter",
        formatting: "Auto Formatting",
        json5Support: "JSON5 Support"
      }
    }
  },
  de: {
    translation: {
      // SEO and Meta
      seo: {
        title: "JSON Pfad Finder - Online JSON Analyzer & Pfad Extraktor Tool",
        description: "Kostenloses Online JSON Pfad Finder und Analyzer Tool. Extrahieren Sie Pfade aus JSON Daten, validieren Sie JSON Struktur, formatieren Sie JSON mit Syntax-Hervorhebung. Perfekt für API Testing und Entwicklung.",
        keywords: "json pfad finder, json analyzer, json validator, json formatieren, api tool, json extraktor, online json tool"
      },
      
      // Header
      header: {
        title: "JSON Pfad Finder",
        subtitle: "JSON-Struktur analysieren und Pfade einfach extrahieren",
        json5Support: "JSON5 (Kommentare)"
      },
      
      // JSON Input
      jsonInput: {
        title: "JSON Eingabe",
        subtitle: "Fügen Sie Ihr JSON-Objekt unten ein",
        subtitleJson5: "Fügen Sie Ihr JSON-Objekt unten ein (JSON5 Kommentare unterstützt)",
        placeholder: "Fügen Sie hier Ihr JSON ein...",
        formatButton: "Formatieren",
        highlightButton: "Hervorheben",
        formatTooltip: "JSON formatieren",
        highlightTooltip: "Syntax-Hervorhebung umschalten"
      },
      
      // JSON Paths
      jsonPaths: {
        title: "JSON Pfade",
        subtitle: "Klicken Sie zum Auswählen eines Pfads, erweitern/reduzieren mit Pfeilen",
        noData: "Keine JSON-Daten anzuzeigen",
        noDataHint: "Fügen Sie gültiges JSON im linken Bereich ein, um Pfade zu sehen",
        noMatches: "Keine Treffer gefunden",
        noMatchesHint: "Versuchen Sie, Ihre Suchanfrage anzupassen oder die Regex-Syntax zu überprüfen"
      },
      
      // Search
      search: {
        placeholder: "Pfade durchsuchen (unterstützt Regex)...",
        searchingFor: "Suche nach:",
        regexMode: "REGEX",
        enableRegex: "Regex-Modus aktivieren",
        disableRegex: "Regex-Modus deaktivieren"
      },
      
      // Selected Path
      selectedPath: {
        title: "Ausgewählter Pfad:",
        copied: "Pfad in die Zwischenablage kopiert! Klicken Sie auf einen beliebigen Pfad zum Kopieren.",
        highlighted: "Hervorgehoben:",
        line: "Zeile"
      },
      
      // Errors and Validation
      errors: {
        jsonError: "JSON Fehler:",
        suggestion: "Vorschlag:",
        invalidRegex: "Ungültiges Regex-Muster:",
        regexHelp: "Bitte überprüfen Sie die Syntax Ihres regulären Ausdrucks"
      },
      
      // Toast Messages
      toast: {
        pathCopied: "Pfad in die Zwischenablage kopiert!"
      },
      
      // Footer
      footer: {
        copyright: "Alle Rechte vorbehalten.",
        privacy: "Datenschutz",
        imprint: "Impressum"
      },
      
      // Tool Features (for SEO)
      features: {
        pathExtraction: "Pfad-Extraktion",
        jsonValidation: "JSON-Validierung",
        syntaxHighlighting: "Syntax-Hervorhebung", 
        searchFilter: "Suchen & Filtern",
        formatting: "Auto-Formatierung",
        json5Support: "JSON5-Unterstützung"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;